export default __webpack_public_path__ + "static/media/profile_temp.d0f55076.svg";